module.exports = __webpack_public_path__ + "static/img/degarde_logo.4546a6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/degarde_logo.png
// module id = 294
// module chunks = 1